import { useState, useEffect } from 'react';
import { usePasswordReset } from '../../hooks/usePasswordReset';

interface ResendResetLinkProps {
  email?: string;
  onSuccess?: () => void;
}

export const ResendResetLink = ({ email: propEmail, onSuccess }: ResendResetLinkProps) => {
  const [email, setEmail] = useState(propEmail || '');
  const [showForm, setShowForm] = useState(false);
  const { sendResetEmail, isLoading, getStoredResetInfo } = usePasswordReset();

  useEffect(() => {
    if (!propEmail) {
      const { email: storedEmail } = getStoredResetInfo();
      if (storedEmail) {
        setEmail(storedEmail);
      }
    }
  }, [propEmail, getStoredResetInfo]);

  const handleResend = async () => {
    if (!email) return;
    
    const success = await sendResetEmail(email);
    if (success && onSuccess) {
      onSuccess();
    }
  };

  if (!showForm && email) {
    return (
      <div className="text-center p-4 bg-blue-50 rounded-xl border border-blue-200">
        <p className="text-sm text-blue-700 mb-3">
          Link reset untuk <strong>{email}</strong> mungkin sudah kadaluarsa?
        </p>
        <button
          onClick={() => setShowForm(true)}
          className="text-sm text-blue-600 hover:text-blue-700 font-medium underline"
        >
          Kirim ulang link reset
        </button>
      </div>
    );
  }

  return (
    <div className="p-4 bg-yellow-50 rounded-xl border border-yellow-200">
      <h3 className="text-sm font-medium text-yellow-800 mb-3">
        Kirim Ulang Link Reset
      </h3>
      
      <div className="space-y-3">
        <input
          type="email"
          placeholder="Masukkan email Anda"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full px-3 py-2 text-sm border border-yellow-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:border-transparent"
          disabled={isLoading}
        />
        
        <div className="flex gap-2">
          <button
            onClick={handleResend}
            disabled={!email || isLoading}
            className="flex-1 px-3 py-2 text-sm bg-yellow-600 text-white rounded-lg hover:bg-yellow-700 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isLoading ? 'Mengirim...' : 'Kirim Ulang'}
          </button>
          
          {showForm && (
            <button
              onClick={() => setShowForm(false)}
              className="px-3 py-2 text-sm text-yellow-600 border border-yellow-300 rounded-lg hover:bg-yellow-100"
            >
              Batal
            </button>
          )}
        </div>
      </div>
    </div>
  );
};